import React from 'react';
import { Divider, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';

const { Title } = Typography;

const teamMembers = [
  ['Dr. Muhammad Shafique', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-01.jpg')],
  ['Dr. Saad Khan', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-02.jpg')],
  ['Dr. Liaqat Ali', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-03.jpg')],
  ['Dr. Muhammad Hanif', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-04.jpg')],
  ['Dr. Muhammad Ali', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-05.jpg')],
  ['Dr. Saleem Ullah', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-06.jpg')],
  ['Dr. Khaista Rehman', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-07.jpg')],
  ['Dr. Sohail Wahid', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-08.jpg')],
  ['Dr. Waqas Ahmed', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-09.jpg')],
  ['Dr. M. Younis Khan', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-10.jpg')],
  ['Mr. Muhammad Suliman', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-11.jpg')],
  ['Mr. Manzoor Ilahi', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-12.jpg')],
  ['Mr. Muhammad Ishfaq', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-13.jpg')],
  ['Dr. Nisar Ali Shah', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-14.jpg')],
  ['Mr. Abubakar', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-15.jpg')],
  ['Dr. Muhammad Nouman', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-16.jpg')],
  ['Dr. Jabir Nazir', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-17.jpg')],
  ['Dr. Banazeer Iqbal', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-18.jpg')],
  ['Mr. Luqman Khan', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-19.jpg')],
  ['Mr. Talha Mahboob', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-20.jpg')],
  ['Mr. Sohail Mehmood', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-21.jpg')],
  ['Mr. Muhammad Imran Ali', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-22.jpg')],
  ['Dr. Muhammad Shahab', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-23.jpg')],
  ['Dr. Tanveer Ahmad', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-24.jpg')],
  ['Mr. Muhammad Noor Taj', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-25.jpg')],
  ['Mr. Salik Javed', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-26.jpg')],
  ['Mr. Bahram Khan', require('../../../Assets/ResearchLabs/GSAGL/Team/GSAGL-Team-27.jpg')],
];

const OurTeam = () => (
  <section className="sarl-team-section" aria-labelledby="gsagl-team-title">
    <div className="sarl-team-inner">
      <Title level={2} id="gsagl-team-title" className="sarl-team-title">Our Team</Title>
      <Divider className="ncgsa-divider" />

      <div className="sarl-team-grid">
        {teamMembers.map(([name, image]) => (
          <article className="sarl-team-member" key={name}>
            <img src={image} alt={name} className="sarl-team-photo" loading="lazy" />
            <h3>{name}</h3>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default OurTeam;
